import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import {
  PROJECT_RIGHTS,
  PROJECT_RIGHTS_FILTERS,
  PROJECT_RIGHTS_UPDATE_ACCESS,
  PROJECT_RIGHTS_EXPORT,
} from '../resources/endPoint';

const buildProjectMsApiUrl = (path) => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};

export const projectRightsBaseURL = buildProjectMsApiUrl(PROJECT_RIGHTS);

/**
 * GET /v1/project-rights/filters
 * Returns { employees, verticals, types, statuses }
 */
export const getProjectRightsFilters = () => ({
  url: PROJECT_RIGHTS_FILTERS,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

/**
 * GET /v1/project-rights?empId=&verticalId=&typeId=&statusId=
 * Returns { employee, projects: [{ projectId, projectName, ... , hasAccess }] }
 */
export const getProjectRightsRequest = ({ empId = '', verticalId = '', typeId = '', statusId = '' } = {}) => {
  const params = new URLSearchParams();
  if (empId) params.append('empId', empId);
  if (verticalId) params.append('verticalId', verticalId);
  if (typeId) params.append('typeId', typeId);
  if (statusId) params.append('statusId', statusId);
  const query = params.toString();
  return {
    url: query ? `${PROJECT_RIGHTS}?${query}` : PROJECT_RIGHTS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

/**
 * POST /v1/project-rights/update-access
 * Body: { empId, selectedProjectIds: [id1, id2, ...] }
 */
export const updateProjectAccessRequest = (payload) => ({
  url: PROJECT_RIGHTS_UPDATE_ACCESS,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});

/**
 * GET /v1/project-rights/export?empId=&verticalId=&typeId=&statusId=
 * Downloads filtered project data as CSV
 */
export const exportProjectRightsRequest = ({ empId = '', verticalId = '', typeId = '', statusId = '' } = {}) => {
  const params = new URLSearchParams();
  if (empId) params.append('empId', empId);
  if (verticalId) params.append('verticalId', verticalId);
  if (typeId) params.append('typeId', typeId);
  if (statusId) params.append('statusId', statusId);
  const query = params.toString();
  return {
    url: query ? `${PROJECT_RIGHTS_EXPORT}?${query}` : PROJECT_RIGHTS_EXPORT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

